import { InteractaIcon } from '@interacta-shared/util';
import { IWorkspace } from '@interacta/util-community';
import { AppRouterState } from '@modules/core/store/app-router.serializer';

export type SidebarWorkspace = Pick<
    IWorkspace,
    'id' | 'name' | 'visibleInOrganizationTree' | 'communities'
>;

export type SidebarSectionId =
    | 'home'
    | 'people'
    | 'community'
    | 'manage'
    | 'insights'
    | 'digital_workplace_admin'
    | 'i-lab';

export interface BaseSidebarSection {
    label: string;
    path?: string;
    icon?: InteractaIcon;
    iconPosition?: 'left' | 'right';
    hidden?: boolean;
    testId?: string;
}
export interface SidebarSection extends BaseSidebarSection {
    id: SidebarSectionId;
    authRequired?: boolean;
}

export type SectionSelected = {
    sectionId: SidebarSectionId;
    route: AppRouterState;
};

export const CreateButtonSections: SidebarSectionId[] = [
    'home',
    'community',
    'people',
    'manage',
    'insights',
    'digital_workplace_admin',
    'i-lab',
];

export const CreateButtonDisabledSections: SidebarSectionId[] = [
    'people',
    'insights',
    'digital_workplace_admin',
    'i-lab',
];
